const PlanPrice = ({ price }) => {
  return (
    <div className="h1 mt-1 fw-bold text-black d-flex align-items-end">
      {price}
    </div>
  );
};

export default PlanPrice;
